var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlurIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6654 10.0007C12.6654 12.3018 10.7999 14.1673 8.4987 14.1673C6.19751 14.1673 4.33203 12.3018 4.33203 10.0007C4.33203 9.44334 4.51702 8.64446 4.84457 7.72735C5.16806 6.82159 5.61528 5.84226 6.10492 4.93913C6.59564 4.03399 7.12037 3.22126 7.59402 2.64232C7.83175 2.35174 8.04508 2.13435 8.2239 1.99412C8.39934 1.85655 8.48638 1.8369 8.49771 1.83434C8.49816 1.83424 8.49849 1.83417 8.4987 1.83412C8.49891 1.83417 8.49924 1.83424 8.49968 1.83434C8.51102 1.8369 8.59806 1.85655 8.77349 1.99412C8.95232 2.13435 9.16564 2.35174 9.40338 2.64232C9.87703 3.22126 10.4018 4.03399 10.8925 4.93913C11.3821 5.84226 11.8293 6.82159 12.1528 7.72735C12.4804 8.64446 12.6654 9.44334 12.6654 10.0007Z",
    stroke: "#0e0333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.6667C9.83333 12.6667 11.1667 11.3333 11.1667 10",
    stroke: "#0e0333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurIconActive);
export default __webpack_public_path__ + "static/media/blur-icon-active.df8f143da0cd08ac7fc384a1cdacd619.svg";
export { ForwardRef as ReactComponent };